module.exports = __webpack_public_path__ + "img/ai-tic-tac-toe-1.e7fc97dc.png";